export default {
    newDesign: true,
    parameters: {
        landing_id: "BRLquizDsh",
        segment: 42,
        success_page: "success_long",
    },
    title:
        "Responda a estas perguntas e ganhe uma aula experimental para seu filho/a! | Kodland",
    downtimeUrl: "https://www.kodland.org/pt",
    startPage: {
        title:
            "Responda a estas perguntas e ganhe uma aula experimental para seu filho/a!",
        subtitle:
            "📕 Aulas para crianças de 8 a 17 anos<br>💻 Só precisa de um computador e acesso à internet<br>💙 Já escolhido por mais de 200.000 pais",
        image: {
            url: "/welcome/brazil_scoring_google_desk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/brazil_scoring_google_mob.png",
            style: {
                width: "100%",
            },
        },
        button: "Começar →",
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "Obrigado por confiar em nossa plataforma educacional!",
        subtitle:
            "Infelizmente, tablets ou telefones não são adequados para assistir às nossas aulas. Ficaremos felizes em vê-lo em nossas aulas na próxima vez!",
    },
    quizRotateBySteps: {
        1: {
            title: "Quantos anos tem o seu filho?",
            type: "age",
            button: "",
        },
        2: {
            question: "Quais atividades atraem seu filho?",
            answers: [
                "Esportes ou dança ⚽💃",
                "Artes criativas 🎨🖌️",
                "Atividades intelectuais 🧩♟️💻",
                "Jogos ou vídeos 🎮📺",
                "Outro 🙂"
            ],
        },
        3: {
            question: "Na escola, quais atividades ou matérias seu filho(a) mais gosta?",
            answers: [
                "Experimentos de ciências ou desafios de matemática 🧪🔢",
                "Leitura ou escrita 📚✍️",
                "Arte, música ou teatro 🎨🎶🎭",
                "Educação física ou esportes 🏃‍♀️⚽🏋️‍♂️",
                "Tecnologia ou computadores 💻📱",
                "Outro 🙂"
            ],
        },
        4: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/brazil_graph.webp",
            subtitle:
                "Embora seja recomendado que as crianças não passem mais de 2 horas por dia em dispositivos, na América Latina frequentemente ultrapassam as 5 horas. É aconselhável alternar entretenimento com atividades produtivas, como aulas de 1 a 1,5 horas.<br><br>Nossos programas foram projetados com isso em mente.",
            button: "Muito bem",
        },
        5: {
            question: "Como seu filho aprende ou lembra melhor das coisas novas?",
            answers: [
                "Vendo (aprende de forma visual) 👁️",
                "Fazendo (aprende praticando) 👐",
                "Ouvindo (aprende auditivamente) 🎧",
                "Através de repetição e prática 🔄✏️"
            ],
        },
        6: {
            question:
                "Por quanto tempo seu filho(a) costuma se concentrar em uma atividade?",
            answers: [
                "15 minutos 🕞",
                "30 minutos 🕘",
                "1 hora 🕐",
                "Mais de 1 hora 🕒"
            ],
        },
        7: {
            question: "Quão motivada(o) está sua criança para experimentar coisas novas?",
            answers: [
                "Muito motivada(o) ✨💪",
                "Precisa de incentivo 🤔👍",
                "Pouco motivada(o) 😕"
            ],
        },
        8: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/brazil_review.webp",
            subtitle:
                "Somos recomendados por pais de todo o mundo. Esperamos que em breve você se junte a eles 💙",
            button: "Estamos quase lá",
        },
        9: {
            question:
                "Seu filho tem acesso a um laptop ou computador para estudar?",
            answers: [
                "Sim, ele tem o próprio dispositivo 💻✅",
                "Sim, mas ele compartilha com outras pessoas 🖥️👫",

                {
                    answer: "Não, ele não tem acesso regular 🚫",
                    stopAnswer: true,
                },
            ],
        },
        10: {
            question: "Seu filho está confortável com tecnologia?",
            answers: [
                "Muito confortável, usa frequentemente 💻✔️",
                "Consegue tarefas básicas, mas precisa de orientação 🖱️❓",
                "Não está familiarizado 🚫"
            ]
        },
        11: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/br_team.png",
            title: "Aulas conduzidas por especialistas em tecnologia e educação",
            button: "Parece ótimo",
        },
        12: {
            question: "O que faz seu filho se sentir orgulhoso ou realizado?",
            answers: [
                "Completar uma tarefa desafiadora 🏆🧠",
                "Ajudar os outros ou contribuir 🤝❤️",
                "Aprender algo novo 📚✨",
                "Receber feedback positivo 🥳👏",
                "Resolver um problema complicado 🔍🧩"
            ]
        },
        13: {
            question: "Você gostaria que seu filho(a) explorasse habilidades do futuro, como programação ou inteligência artificial?",
            answers: [
                "Sim 👍✨",
                "Talvez mais tarde ⏳🤔",
                "Não ❌"
            ]
        },
        14: {
            typeInfo: "loaderScreen",
            sliderImages: [
                "/welcome/br_longquiz_dev_2_r1.png",
                "/welcome/br_longquiz_dev_2_r2.png",
                "/welcome/br_longquiz_dev_2_r3.png",
            ],
            sliderImagesMobile: [
                "/welcome/br_longquiz_dev_2_r1_mob.png",
                "/welcome/br_longquiz_dev_2_r2_mob.png",
                "/welcome/br_longquiz_dev_2_r3_mob.png",
            ],
            textLoader: "Criando o plano de aprendizagem personalizado do seu filho",
            titleLoader: 'Confiado por mais de <span style="color: rgba(89, 136, 255, 1)">3.000.000</span> de pais e alunos',
            subtitleLoader: "⭐ 4,8 / 5 — baseado em mais de 50.000 avaliações",
        },
        15: {
            title: "Agende uma aula gratuita",
            type: "one-page-contacts",
            subtitle: "",
            button: "Quase lá! 🔥",
        },
        16: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        17: {
            title: "Obrigado 🎉 Faltam apenas alguns passos para concluir o cadastro",
            typeInfo: "pc-laptop",
            subtitle:
                "Por favor, observe que você precisará de um PC ou laptop funcional para a aula e que deve acompanhar seu filho durante toda a aula. Lembre-se de que a aula é individual e personalizada.",
            button: "O que mais?",
        },
        18: {
            title: "Verifique seu e-mail e WhatsApp antes da aula experimental 📞",
            typeInfo: "whatsapp",
            subtitle:
                "Enviaremos um lembrete 24 horas antes da aula e 2 horas antes da aula pediremos para você confirmar sua presença. É muito importante que mantenhamos contato para que a aula não seja cancelada.",
            button: "O que mais?",
        },
        19: {
            title: "A aula vai acontecer na nossa plataforma 💻",
            typeInfo: "classroom",
            subtitle:
              "Você vai receber um link e um código único pelo WhatsApp e e-mail. Basta clicar no link, ele vai te levar direto para a aula. Sem aplicativos extras, sem downloads.",
            button: "Entendi ✅",
        },
    },
};
